import React, { Fragment } from 'react';
import InterviewDetails from '../../../Client/ClientInterviewSchedular/InterviewDetails/InterviewDetails';
import SelectedCandidates from '../../../Client/ClientInterviewSchedular/SelectedCandidates/SelectedCandidates';
import SelectedDateTime from '../../../Client/ClientInterviewSchedular/SelectedDateTime/SelectedDateTime';
import './ConfirmDetailsStep4.css';
import moment from 'moment';
import MediaQuery from 'react-responsive';
import Textarea from '../../Textarea/Textarea';
import AttachFile from '../../../../hoc/AttachFile/AttachFile';



const ConfirmDetailsStep4 = (props) => {

  let candidates = [];
  let candidateSlots = [];
  if(props.data.candidateDetails&&props.data.candidateDetails.length >0){

    candidates = props.data.candidateDetails.map((item, index) => {
     return props.candidateData.filter(candidate => candidate.candidate_id === item.id)[0];
    });
  }

  if(props.data.slotDetails && props.data.slotDetails.length > 0) {
    let toDate = "";
    let fromDate="";
    let durationArray = [];
    candidateSlots = props.data.slotDetails.map((item, index) => {
      if(props.data.interviewDuration === "30 mins"){
        fromDate = moment(item.slot).format('hh:mma');
        toDate = moment(item.slot).add(30, 'minutes').format('hh:mma');
      }else{
        durationArray = props.data.interviewDuration.split(" ");
        fromDate = moment(item.slot).format('hh:mma');
        toDate = moment(item.slot).add(durationArray[0], 'hours').format('hh:mma');
      }
      return {date: moment(item.slot).format('ddd D MMMM YYYY'), time: fromDate+ " - " + toDate} 
    })
  }
  var fileTypes = ["application/vnd.openxmlformats-officedocument.wordprocessingml.document","application/msword","image/jpeg", "image/jpg", "image/png", "image/gif", "application/pdf", "application/vnd.ms-powerpoint", "application/vnd.openxmlformats-officedocument.presentationml.presentation"];
  
  return(
    <div className="confirm-details-step-four">
      {props.data.requestedBy?
      <Fragment>
        <MediaQuery query="(min-device-width: 768px)">
          <div className="client-wrap">
            <div className="client-head">
              <h4 className="client-note">Note from your client </h4>
              <span className="prefix-client-info">(This note is only visible to you)</span>
              <span className="prefix-author">Interview created by: {props.data.requestedBy}</span>
            </div>
            <div className="prefix-client-message desktop-padding">"{props.data.interviewMessage?props.data.interviewMessage:"Not Specified"}"</div>
          </div>
        </MediaQuery>
        <MediaQuery query="(max-device-width: 767px)">
          <div className="client-wrap">
            <div className="client-head">
            <span className="prefix-author">Interview created by: {props.data.requestedBy}</span>
              <h4 className="client-note">Note from your client </h4>
              <span className="prefix-client-info">(This note is only visible to you)</span>
            </div>
            <div className="prefix-client-message">"{props.data.interviewMessage?props.data.interviewMessage:"Not Specified"}"</div>
          </div>
        </MediaQuery>
        <div className="display-info">
          <h4>The client has selected the following candidates, dates and times for interview.</h4>
          <p>Please review and edit any details where necessary.</p>
        </div>
      </Fragment>
      :null}
      <InterviewDetails 
      interviewLocation={props.data.interviewLocation}
      interviewType={props.data.interviewType}
      />
      <SelectedCandidates candidates={candidates} userType = {props.userType}/>
      <SelectedDateTime candidateSlots={candidateSlots}/>
      {props.data.requestedBy?null:props.data.interviewMessage?<div className="recruiter-message">
        <h4 className="rec-message-title">Note to your recruiter</h4>
        <p className="rec-message-text">{props.data.interviewMessage}</p>
      </div>: null}
      {props.data.requestedBy?
      <div className="notes">
          <p>Would you like to send a note to your candidate(s)?</p>
          <Textarea
            name="textarea-message" 
            placeholder="Add your note here"
            value={props.interviewMessage}
            onChange={(e) => props.handleInterviewMessage(e)}
            >
          </Textarea>
          <AttachFile 
                  multiple={true}
                  buttonText="Browse Files"
                  maxSize ={1024*5120}
                  acceptedTypes = ".doc,.docx,.jpg,.jpeg,.png,.gif,.pdf,.ppt,.pptx"
                  DragAcceptedTypes = {fileTypes}
                  handleFileSelect={props.addFile}
                  handleFileRemove={props.handleRemoveFile}
                  onclickAttach = {props.handleAttachClick}
                  progressPercent={props.progressPercent}
                  selectedFiles = {props.interviewAttachments}
                  />
        </div>:""}
    </div>
  );
}

export default ConfirmDetailsStep4;


// WEBPACK FOOTER //
// ./src/components/UI/StepperContent/ConfirmDetailsStep4/ConfirmDetailsStep4.js